import { CalendarErrorRecordItem } from "@modules/global-dashboard/models/global-dashboard-interface";

export interface MilestoneEventHistoryLogData {
	milestoneId: string;
	milestoneType: string;
	customerExternalId: string;
	customerName: string;
	payGroupId: string;
	paygroupName: string;
	cycleName: string;
	group: string;
	payCycleId?: string;
}

export interface TransactionHistoryLogData {
	payoutId: string;
	paymethodId: string;
}

export interface MilestoneHistoryLogItem {
	historyLogType: MilestoneHistoryLogType;
	createdAt: string;
	userId: string;
	userName?: string;
	status?: string;
	title: HistoryLogTextSegment[];
	subtitle?: string;
}

export interface HistoryLogTextSegment {
	text: string;
	style?: "normal" | "highlight";
}

export enum HistoryLogType {
	MILESTONE = "MILESTONE",
	TRANSACTION = "TRANSACTION"
}

export enum MilestoneHistoryLogType {
	STATUS = "STATUS",
	NOTIFICATION = "NOTIFICATION",
	OTHER = "OTHER",
	CALENDAR_ERROR = "CALENDAR ERROR"
}

export type MilestoneHistoryLog = MilestoneHistoryLogItem | CalendarErrorRecordItem;
